export class DashboardModel {
    public allUsersCount: number;
    public activeUsersCount: number;

    public allProductsCount: number;
    public activeProductsCount: number;

    public allAccessoriesCount: number;
    public activeAccessoriesCount: number;

    public allOffersCount: number;
    public activeOffersCount: number;

    public allRegionsCount: number;
    public activeRegionsCount: number;

    public allCategoriesCount: number;
    public activeCategoriesCount: number;
}